module.exports = __webpack_public_path__ + "static/media/main_ourstudents.871d93b8.png";